import { useEffect, useState } from 'react';
import CharCount from '../../../components/charCount/CharCount';

export default function UserDetails({ muBookData, handleUser, custom }) {
    const [seatCount, setSeatCount] = useState(muBookData.totalSeats);
    useEffect(() => {
        setSeatCount(muBookData?.totalSeats);
    }, [muBookData.totalSeats]);

    if (muBookData.totalSeats === -1) {
        return;
    }
    muBookData.userDetails.length = custom ? seatCount : muBookData.totalSeats;
    return (
        <div className='orgAddBoUserDiv'>
            {Array.apply(null, {
                length: custom ? seatCount : muBookData.totalSeats
            }).map(function (_, peopleIndex) {
                if (!muBookData.userDetails[peopleIndex]) {
                    muBookData.userDetails[peopleIndex] = {
                        name: '',
                        age: '',
                        sex: 'Select',
                        emailId: '',
                        countryCode: '+91',
                        phoneNumber: ''
                    };
                }
                return (
                    <div key={peopleIndex} className='reviewBoInfoUserDiv'>
                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Name</label>
                                <input
                                    value={
                                        muBookData?.userDetails[peopleIndex]
                                            ? muBookData?.userDetails[peopleIndex].name
                                            : ''
                                    }
                                    name='name'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder={`Person ${peopleIndex + 1} name`}
                                    className='reviewBoInfoInput'
                                ></input>
                                <CharCount
                                    string={
                                        muBookData?.userDetails[peopleIndex]?.name
                                            ? muBookData?.userDetails[peopleIndex]?.name
                                            : ''
                                    }
                                    min={3}
                                    limit={30}
                                />
                            </div>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Age</label>
                                <input
                                    value={muBookData?.userDetails[peopleIndex]?.age}
                                    name='age'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='number'
                                    placeholder="Person's age"
                                    className='reviewBoInfoInput'
                                ></input>
                            </div>
                        </div>
                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Sex</label>
                                <select
                                    value={muBookData?.userDetails[peopleIndex]?.sex}
                                    name='sex'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    className='reviewBoInfoInput'
                                >
                                    <option value='Select'>Select</option>
                                    <option value='Male'>Male</option>
                                    <option value='Female'>Female</option>
                                    <option value='Others'>Others</option>
                                </select>
                            </div>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Email</label>
                                <input
                                    value={muBookData?.userDetails[peopleIndex]?.emailId}
                                    name='emailId'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder={'Email Id of person ' + (peopleIndex + 1)}
                                    className='reviewBoInfoInput'
                                ></input>
                            </div>
                        </div>
                        <div className='reviewBoInfoNameAge'>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Country code</label>
                                <select
                                    value={muBookData?.userDetails[peopleIndex]?.countryCode}
                                    name='countryCode'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    className='reviewBoInfoInput'
                                >
                                    <option value='+91'>+91</option>
                                </select>
                            </div>
                            <div className='reviewBoInfoName'>
                                <label className='reviewBoInfoLabel'>Phone Number</label>
                                <input
                                    value={muBookData?.userDetails[peopleIndex]?.phoneNumber}
                                    name='phoneNumber'
                                    onChange={(e) => handleUser(e, peopleIndex)}
                                    type='text'
                                    placeholder='Mobile Number'
                                    className='reviewBoInfoInput'
                                ></input>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
